/**
 * ETCレイヤ種別定義
 */
export type ETCLayerType = "ETC_DRM区間" | "ETC_交通調査基本区間";

/**
 * 時/分定義
 */
export type ETCTimeType = "15分" | "1時間";

/**
 * 道路種別定義
 */
export type RoadType =
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "0";

/**
 * ETC_DRM区間_15分レイヤ名
 */
const LAYER_ETC_PROBE_DRM_LNK_15M = "t_etc_probe_drm_lnk_15m";

/**
 * ETC_DRM区間_時間レイヤ名
 */
const LAYER_ETC_PROBE_DRM_LNK_1H = "t_etc_probe_drm_lnk_1h";

/**
 * ETC_交通調査基本区間_15分レイヤ名
 */
const LAYER_ETC_PROBE_TRAFFIC_15M = "t_etc_probe_traffic_15m";

/**
 * ETC_交通調査基本区間_時間レイヤ名
 */
const LAYER_ETC_PROBE_TRAFFIC_1H = "t_etc_probe_traffic_1h";

/**
 * ETCレイヤ指定用クラス（時/分）
 */
export class ETCLayerName {
  /**
   * ETCレイヤ種別
   */
  etcLayerType: ETCLayerType;

  /**
   * 時/分
   */
  etcTimeType: ETCTimeType;

  /**
   * 道路種別
   */
  roadType: RoadType;

  /**
   * 時間コード
   */
  timeCode: string;

  /**
   * ETCレイヤ指定用（時/分）コンストラクタ
   * @param etcLayerType ETCレイヤ種別
   * @param roadType 道路種別
   * @param timeCode 時間コード
   * @param etcTimeType 時/分
   */
  constructor(
    etcLayerType: ETCLayerType,
    roadType: RoadType,
    timeCode: string,
    etcTimeType?: ETCTimeType
  ) {
    (this.etcLayerType = etcLayerType),
      (this.etcTimeType = etcTimeType),
      (this.roadType = roadType),
      (this.timeCode = timeCode);
  }

  /**
   * フィルタ条件文字列を取得
   */
  getCqlFilterString(): string {
    const cqlParameterString = `"道路種別コード"='${
      this.roadType
    }' AND "時間コード"=${this.timeCode ? this.timeCode : 0}`;
    return cqlParameterString;
  }

  /**
   * レイヤ名を取得
   */
  getLayerName(): string {
    let layerName = "";
    if (this.etcLayerType === "ETC_DRM区間") {
      switch (this.etcTimeType) {
        case "15分":
          layerName = LAYER_ETC_PROBE_DRM_LNK_15M;
          break;
        case "1時間":
          layerName = LAYER_ETC_PROBE_DRM_LNK_1H;
          break;
      }
    } else if (this.etcLayerType === "ETC_交通調査基本区間") {
      switch (this.etcTimeType) {
        case "15分":
          layerName = LAYER_ETC_PROBE_TRAFFIC_15M;
          break;
        case "1時間":
          layerName = LAYER_ETC_PROBE_TRAFFIC_1H;
          break;
      }
    }
    return layerName;
  }
}
